export default __webpack_public_path__ + "static/media/arena_1.a5923c1d.jpeg";